import { Link } from 'react-router-dom';
import TerminalPanel from './TerminalPanel';

const tickerData = [
  { symbol: 'HSI', name: '恒生指数', price: '18,293.51', change: '+1.22%', up: true, spark: [17800,17850,17920,17880,17950,18020,18080,18130,18190,18230,18293] },
  { symbol: 'SHCOMP', name: '上证综指', price: '3,341.28', change: '+0.56%', up: true, spark: [3300,3310,3305,3320,3315,3330,3325,3335,3332,3340,3341] },
  { symbol: 'N225', name: '日经225', price: '38,720.15', change: '-0.32%', up: false, spark: [38900,38850,38920,38800,38780,38830,38750,38720,38740,38700,38720] },
  { symbol: 'KOSPI', name: '韩国KOSPI', price: '2,784.36', change: '+0.89%', up: true, spark: [2740,2750,2745,2758,2762,2768,2770,2775,2778,2782,2784] },
  { symbol: 'STI', name: '新加坡海峡', price: '3,421.78', change: '+0.41%', up: true, spark: [3390,3395,3400,3405,3402,3410,3408,3415,3418,3420,3421] },
  { symbol: 'NIFTY', name: '印度Nifty50', price: '23,890.45', change: '+1.15%', up: true, spark: [23500,23580,23620,23650,23700,23720,23780,23810,23840,23870,23890] },
  { symbol: 'SENSEX', name: '印度SENSEX', price: '78,562.30', change: '+0.92%', up: true, spark: [77500,77600,77700,77800,77900,78000,78150,78300,78450,78500,78562] },
  { symbol: 'NASDAQ', name: '纳斯达克', price: '18,542.30', change: '+0.45%', up: true, spark: [18400,18420,18410,18450,18435,18480,18470,18500,18520,18535,18542] },
  { symbol: 'SPX', name: '标普500', price: '5,234.18', change: '+0.72%', up: true, spark: [5180,5190,5185,5200,5195,5210,5215,5225,5220,5230,5234] },
  { symbol: 'FTSE', name: '富时100', price: '8,245.60', change: '-0.18%', up: false, spark: [8270,8280,8275,8265,8272,8260,8255,8262,8250,8248,8245] },
  { symbol: 'DAX', name: '德国DAX', price: '18,670.42', change: '+0.63%', up: true, spark: [18500,18530,18560,18580,18600,18620,18610,18640,18650,18660,18670] },
  { symbol: 'BTC', name: '比特币', price: '67,421.80', change: '+2.34%', up: true, spark: [65200,65500,65800,66000,66200,66500,66800,66900,67100,67300,67421] },
  { symbol: 'XAU', name: '黄金/美元', price: '2,341.50', change: '+0.18%', up: true, spark: [2330,2332,2335,2334,2338,2336,2340,2339,2341,2342,2341] },
  { symbol: 'USD/HKD', name: '美元/港币', price: '7.8125', change: '-0.02%', up: false, spark: [7.8132,7.8130,7.8128,7.8127,7.8129,7.8126,7.8128,7.8124,7.8126,7.8125,7.8125] },
  { symbol: 'VIX', name: '恐慌指数', price: '14.23', change: '-3.21%', up: false, spark: [14.80,14.70,14.65,14.55,14.50,14.40,14.38,14.35,14.30,14.25,14.23] },
];

/* ── Mini Sparkline SVG ── */
function TickerSparkline({ data, up, w, h }: { data: number[]; up: boolean; w: number; h: number }) {
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const pathD = data.map((v, i) => {
    const x = (i / (data.length - 1)) * w;
    const y = h - ((v - min) / range) * (h - 4) - 2;
    return `${i === 0 ? 'M' : 'L'}${x} ${y}`;
  }).join(' ');

  const color = up ? 'rgba(72,209,176,0.7)' : 'rgba(248,113,113,0.7)';

  return (
    <svg width={w} height={h} className="shrink-0 opacity-70" xmlns="http://www.w3.org/2000/svg">
      <path d={pathD} fill="none" stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

const dataBadges = [
  { label: '策略模型', value: '50+', sub: '覆盖多因子/CTA/套利' },
  { label: 'AUM 规模', value: '$2.8B+', sub: '管理资产规模' },
  { label: '风控评分', value: 'AA', sub: '综合风险管理评级' },
  { label: '全球市场', value: '15+', sub: '覆盖核心交易所' },
];

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex flex-col overflow-hidden bg-background-50">

      {/* ========================================
          LAYER 1: Background Image
      ========================================= */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Hong%20Kong%20Victoria%20Harbour%20at%20deep%20twilight%2C%20IFC%20and%20ICC%20skyscrapers%20illuminated%20with%20gold%20and%20cool%20white%20lights%2C%20dramatic%20dark%20navy%20sky%20with%20faint%20stars%2C%20city%20lights%20reflecting%20on%20dark%20rippling%20water%2C%20cinematic%20ultra-wide%20composition%2C%20no%20people%2C%20deep%20shadows%2C%20professional%20architectural%20photography%2C%20moody%20powerful%20atmosphere&width=1920&height=1080&seq=hero-hk-terminal-2026b&orientation=landscape"
          alt="香港国际金融中心夜幕天际线"
          className="w-full h-full object-cover object-top"
        />
        {/* Heavy dark overlay for contrast */}
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/95 via-background-50/60 to-background-50/90"></div>
      </div>

      {/* ========================================
          LAYER 2: Fintech Data Overlays (Grid, Nodes, Lines)
      ========================================= */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">

        {/* Main data grid */}
        <svg className="absolute inset-0 w-full h-full opacity-[0.06]" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="gridGradHero" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#60A8E0" stopOpacity="0.6" />
              <stop offset="50%" stopColor="#C8A840" stopOpacity="0.4" />
              <stop offset="100%" stopColor="#60A8E0" stopOpacity="0.6" />
            </linearGradient>
            <linearGradient id="flowGrad" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="transparent" />
              <stop offset="50%" stopColor="#48D1B0" stopOpacity="0.5" />
              <stop offset="100%" stopColor="transparent" />
            </linearGradient>
            <linearGradient id="flowGradGold" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="transparent" />
              <stop offset="50%" stopColor="#C8A840" stopOpacity="0.5" />
              <stop offset="100%" stopColor="transparent" />
            </linearGradient>
          </defs>
          {/* Horizontal grid lines */}
          {[50, 110, 170, 230, 290, 350, 410, 470, 530, 590, 650, 710, 770, 830, 890, 950].map((y) => (
            <line key={`h-${y}`} x1="0" y1={y} x2="100%" y2={y} stroke="url(#gridGradHero)" strokeWidth="0.5" strokeDasharray="4 80 2 20" opacity={0.5} />
          ))}
          {/* Vertical grid lines */}
          {[10, 22, 35, 48, 60, 72, 85, 95].map((x) => (
            <line key={`v-${x}`} x1={`${x}%`} y1="0" x2={`${x}%`} y2="100%" stroke="url(#gridGradHero)" strokeWidth="0.4" strokeDasharray="2 50" opacity={0.35} />
          ))}
        </svg>

        {/* ── Glowing Data Nodes ── */}
        {[
          { top: '8%', left: '12%', size: 'w-2 h-2', color: 'bg-primary-400', glow: 'shadow-[0_0_10px_rgba(96,168,224,0.7)]', delay: '0s' },
          { top: '14%', left: '35%', size: 'w-1.5 h-1.5', color: 'bg-accent-400', glow: 'shadow-[0_0_8px_rgba(200,168,64,0.6)]', delay: '1s' },
          { top: '10%', left: '58%', size: 'w-2.5 h-2.5', color: 'bg-emerald-400', glow: 'shadow-[0_0_14px_rgba(72,209,176,0.7)]', delay: '0.5s' },
          { top: '20%', left: '78%', size: 'w-1.5 h-1.5', color: 'bg-primary-400', glow: 'shadow-[0_0_8px_rgba(96,168,224,0.6)]', delay: '1.5s' },
          { top: '28%', left: '22%', size: 'w-1 h-1', color: 'bg-accent-400', glow: 'shadow-[0_0_6px_rgba(200,168,64,0.5)]', delay: '2s' },
          { top: '35%', left: '50%', size: 'w-2 h-2', color: 'bg-primary-400', glow: 'shadow-[0_0_12px_rgba(96,168,224,0.7)]', delay: '1.2s' },
          { top: '42%', left: '85%', size: 'w-1.5 h-1.5', color: 'bg-emerald-400', glow: 'shadow-[0_0_8px_rgba(72,209,176,0.6)]', delay: '0.8s' },
          { top: '55%', left: '10%', size: 'w-2 h-2', color: 'bg-accent-400', glow: 'shadow-[0_0_12px_rgba(200,168,64,0.7)]', delay: '0.3s' },
          { top: '65%', left: '38%', size: 'w-1 h-1', color: 'bg-primary-400', glow: 'shadow-[0_0_6px_rgba(96,168,224,0.5)]', delay: '1.8s' },
          { top: '72%', left: '62%', size: 'w-1.5 h-1.5', color: 'bg-emerald-400', glow: 'shadow-[0_0_8px_rgba(72,209,176,0.6)]', delay: '2.2s' },
          { top: '80%', left: '90%', size: 'w-2 h-2', color: 'bg-accent-400', glow: 'shadow-[0_0_10px_rgba(200,168,64,0.7)]', delay: '0.7s' },
          { top: '18%', left: '92%', size: 'w-1 h-1', color: 'bg-primary-400', glow: 'shadow-[0_0_5px_rgba(96,168,224,0.5)]', delay: '1.6s' },
        ].map((node, i) => (
          <div
            key={i}
            className={`absolute ${node.size} ${node.color} ${node.glow} rounded-full animate-node-pulse`}
            style={{ top: node.top, left: node.left, animationDelay: node.delay }}
          />
        ))}

        {/* ── Connection arcs between nodes ── */}
        <svg className="absolute inset-0 w-full h-full opacity-[0.05]" xmlns="http://www.w3.org/2000/svg">
          <path d="M12% 8% Q35% 5% 58% 10%" fill="none" stroke="#60A8E0" strokeWidth="0.5" strokeDasharray="4 6" />
          <path d="M35% 14% Q55% 8% 78% 20%" fill="none" stroke="#C8A840" strokeWidth="0.5" strokeDasharray="3 5" />
          <path d="M22% 28% Q35% 38% 50% 35%" fill="none" stroke="#48D1B0" strokeWidth="0.5" strokeDasharray="3 5" />
          <path d="M58% 10% Q72% 22% 85% 42%" fill="none" stroke="#60A8E0" strokeWidth="0.5" strokeDasharray="4 7" />
          <path d="M10% 55% Q22% 48% 38% 65%" fill="none" stroke="#C8A840" strokeWidth="0.5" strokeDasharray="3 6" />
          <path d="M62% 72% Q75% 68% 90% 80%" fill="none" stroke="#48D1B0" strokeWidth="0.5" strokeDasharray="3 6" />
        </svg>

        {/* ── Glowing Orb Blobs ── */}
        <div className="absolute top-[15%] right-[25%] w-80 h-80 rounded-full bg-primary-500/[0.03] blur-[100px] animate-pulse-glow"></div>
        <div className="absolute bottom-[20%] left-[5%] w-96 h-96 rounded-full bg-accent-500/[0.04] blur-[120px] animate-pulse-glow" style={{ animationDelay: '1.8s' }}></div>
        <div className="absolute top-[50%] left-[60%] w-64 h-64 rounded-full bg-emerald-400/[0.03] blur-[80px] animate-pulse-glow" style={{ animationDelay: '3s' }}></div>

        {/* ── Scanning line overlay ── */}
        <div className="absolute inset-0 scan-line opacity-20"></div>
      </div>

      {/* ========================================
          LAYER 3: Enhanced Global Market Ticker
      ========================================= */}
      <div className="relative z-30 w-full bg-background-100/50 backdrop-blur-md border-b border-background-300/30">
        {/* Row 1: Global Indices */}
        <div className="flex items-center h-10 overflow-hidden">
          {/* Ticker label */}
          <div className="shrink-0 px-4 h-full flex items-center gap-2 bg-background-50 border-r border-background-300/30 z-10">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse-glow"></span>
            <span className="mono-data text-[10px] text-foreground-400 tracking-[0.15em] uppercase font-semibold whitespace-nowrap">Global Markets</span>
          </div>

          {/* Scrolling ticker track */}
          <div className="flex-1 overflow-hidden relative">
            <div className="ticker-track py-1.5">
              {[...tickerData, ...tickerData].map((item, i) => (
                <div key={i} className="flex items-center gap-2.5 px-5 border-r border-background-300/20 shrink-0">
                  <span className="mono-data text-[10px] text-foreground-500 font-medium tracking-wide whitespace-nowrap">{item.symbol}</span>
                  <span className="mono-data text-[11px] text-foreground-200 font-bold tabular-nums whitespace-nowrap">{item.price}</span>
                  <span className={`mono-data text-[10px] font-semibold tabular-nums whitespace-nowrap ${item.up ? 'text-emerald-400' : 'text-red-400'}`}>
                    {item.change}
                  </span>
                  <TickerSparkline data={item.spark} up={item.up} w={48} h={16} />
                </div>
              ))}
            </div>
          </div>

          {/* Right fade edge */}
          <div className="shrink-0 w-16 h-full bg-gradient-to-l from-background-100/50 to-transparent pointer-events-none z-10"></div>
        </div>
      </div>

      {/* ========================================
          LAYER 4: Main Content Area (Left Text + Right Terminal)
      ========================================= */}
      <div className="relative z-20 flex-1 flex items-center px-6 md:px-12 lg:px-16 pt-28 md:pt-36 lg:pt-32">
        <div className="w-full max-w-[1500px] mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-16">

          {/* ── LEFT: Title + Badges + CTA ── */}
          <div className="flex-1 w-full text-center lg:text-left">

            {/* Status indicator */}
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-accent-500/20 bg-accent-500/[0.05] backdrop-blur-sm mb-8">
              <span className="flex w-2 h-2 rounded-full bg-emerald-400 animate-pulse-glow"></span>
              <span className="mono-data text-[10px] md:text-[11px] text-accent-400 tracking-[0.15em] uppercase">SYSTEM ONLINE · 香港国际金融中心</span>
            </div>

            {/* Main heading */}
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-6xl xl:text-7xl font-heading font-bold text-white leading-[1.08] mb-6">
              <span className="block">量化驱动 · 智慧资管</span>
              <span className="block mt-3 bg-gradient-to-r from-accent-400 via-accent-300 to-primary-300 bg-clip-text text-transparent">
                连接全球资产价值
              </span>
            </h1>

            {/* Subtitle with terminal styling */}
            <p className="text-sm md:text-base text-foreground-400 leading-relaxed max-w-xl mb-2 font-light">
              香港蚂蚁链控股集团立足香港国际金融中心，以量化科技为核心驱动力，深耕基金管理、家族办公室与资本投资三大资产管理板块，构建面向未来的科技金融生态。
            </p>

            {/* Data badges row */}
            <div className="flex flex-wrap items-center gap-3 md:gap-4 justify-center lg:justify-start mb-8 mt-5">
              {dataBadges.map((badge, i) => (
                <div
                  key={badge.label}
                  className="terminal-module px-4 py-2.5 flex items-center gap-3 animate-fade-in-up"
                  style={{ animationDelay: `${0.4 + i * 0.12}s` }}
                >
                  <span className="mono-data text-lg md:text-xl font-bold text-foreground-100 leading-none">{badge.value}</span>
                  <div className="text-left leading-tight">
                    <span className="block text-[10px] text-foreground-500 font-medium">{badge.label}</span>
                    <span className="block text-[9px] text-foreground-600 font-light">{badge.sub}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA buttons */}
            <div className="flex flex-col sm:flex-row items-center lg:items-start gap-3">
              <Link
                to="/business"
                className="group flex items-center gap-2.5 px-7 py-3.5 bg-accent-500 text-background-950 font-bold text-sm rounded-full hover:bg-accent-400 transition-all duration-300 whitespace-nowrap shadow-[0_0_30px_rgba(200,160,80,0.15)] hover:shadow-[0_0_40px_rgba(200,160,80,0.25)]"
              >
                探索核心业务
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300"></i>
              </Link>
              <Link
                to="/about"
                className="flex items-center gap-2 px-7 py-3.5 border border-foreground-400/25 text-foreground-200 text-sm font-medium rounded-full hover:bg-background-200/40 hover:border-foreground-300/40 transition-all duration-300 whitespace-nowrap"
              >
                了解集团
                <i className="ri-arrow-right-up-line text-sm"></i>
              </Link>
            </div>
          </div>

          {/* ── RIGHT: Dynamic Quant Terminal Panel ── */}
          <div className="flex-1 w-full max-w-[580px] lg:max-w-[620px]">
            <TerminalPanel />
          </div>
        </div>
      </div>

      {/* ========================================
          LAYER 5: Bottom Fade + Scroll Indicator
      ========================================= */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 via-background-50/60 to-transparent pointer-events-none"></div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-30">
        <span className="mono-data text-[10px] text-foreground-600 tracking-[0.3em] uppercase">Scroll Down</span>
        <div className="w-4 h-7 rounded-full border border-foreground-600/25 flex items-start justify-center p-1">
          <div className="w-1 h-2.5 rounded-full bg-accent-400/50 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}